<template>
  <NavComponents />
  
  <div class="container">

    <el-row :gutter="20">
            <el-col :span="7" class="infoBorder" v-if="certifica != null && certifica.states == 1">
                <!-- 学习认证 -->
                <span class="font_1">专业认证证书</span>
                <img :src="certifica.link" class="certifica">
            </el-col>
            <el-col :span="3" class="infoBorder" v-if="certifica != null && certifica.states == 1">
              <el-button type="success" class="cBtn" @click="reApplyCertifica(certifica.link, certifica.certificaId)" plain>重新申请</el-button>
              <el-button type="warning" class="cBtn" @click="download(certifica.link)" plain>下载证书</el-button>
            </el-col>

            <el-col :span="7" class="infoBorder" v-if="certifica == null || certifica.states == 0">
                <!-- 学习认证 -->
                <span class="font_1">专业认证模版</span>
                <img src="@/assets/img/card/certificate.jpg" class="certifica">
            </el-col>
            <el-col :span="3" class="infoBorder" v-if="certifica == null || certifica.states == 0">
              <el-button type="success" class="cBtn" @click="applyCertifica()" plain>申请证书</el-button>
            </el-col>
            <el-col :span="3" class="infoBorder" v-if="certifica != null && certifica.states == 0">
                 <el-button type="warning" class="cBtn" plain>审核中</el-button>
            </el-col>
        </el-row>
    
    <table class="table caption-top">
      <caption>
        必学课程
      </caption>
      <thead>
        <tr>
          <th scope="col">课程名称</th>
          <th scope="col">课程封面</th>
          <th scope="col">完成状况</th>
          <th scope="col">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="course in courseList" :key="course.courseId">
          <td>{{ course.courseName }}</td>
          <td><img :src="course.courseImg" class="courseImg"></td>
          <td>
            <el-button type="info" class="Btn2" v-if="course.hasLearn == 0" plain>
                  未完成
            </el-button>
            <el-button type="success" class="Btn2" v-if="course.hasLearn == 1" plain>
                  已完成
            </el-button>
          </td>

          <td>
              <el-button type="warning" class="Btn2" @click="joinCourse(course.courseId)" plain>
                  去学习
              </el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <NavFooter/>
</template>

<script setup>
import NavComponents from "@/components/nav/NavComponents.vue";
import NavFooter from '@/components/nav/NavFooter.vue'
import { ref, onMounted } from "vue";
  import $ from "jquery";
  import { ElMessage, ElMessageBox  } from "element-plus";
  import { useRoute } from "vue-router";
 // import router from "@/router/index"; 
  

  const professionalId = ref('');
  const Route = useRoute(); //获取到值
const courseList = ref();
const certifica = ref();
  const token = localStorage.getItem("token");
  
  onMounted(() => {
      // 获取路由参数并设置为 current_page
    professionalId.value = Route.params.professionalId || '';
    getCourse();
  });
  

  const getCourse = () => {
    $.ajax({
      url: "http://124.222.105.205:5000/api/statistics/getMustLearnCourse",
      data: {
        professionalId: professionalId.value
      },
      type: "post",
      headers: {
        Authorization: "Bearer " + token,
      },
      success(resp) {
        if (resp.code == "200") {
          certifica.value = resp.data.certifica;
          courseList.value = resp.data.courseList;
        }
        console.log(resp.data);
        
      },
      error() {
        ElMessage({
          type: "error",
          message: "拉取信息失败!"
        });
      },
    });
  };

  const joinCourse = (id) => {
  const a = document.createElement('a');
  a.href = `/CourseDetail/${id}`; // 假设课程详情页面的路由是/course/:courseId
  a.target = '_blank'; // 在新页面中打开
  a.click(); // 触发点击事件
}

const download = (link) => {
  const element = document.createElement('a');
  element.setAttribute('href', link);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

const applyCertifica = () => {

    ElMessageBox.confirm("确认申请专业证书吗?", "申请专业证书", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/applyProfessionalCertifica",
        data: {
          professionalId: professionalId.value
        },
        type: "post",
        headers: {
          Authorization: "Bearer " + token,
        },
        success(resp) {
          if (resp.code == "200") {
            ElMessage({
              type: "success",
              message: resp.msg
            });
            getCourse();
          } else {
            ElMessage({
              type: "error",
              message: resp.msg
            });
          }
        },
        error() {
          ElMessage({
            type: "error",
            message: "服务端异常!请稍后再试!"
          });
        },
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消",
      });
    });
  };

  const reApplyCertifica = (link, id) => {

ElMessageBox.confirm("确认重新申请申请专业证书吗?", "重新申请专业证书", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
})
.then(() => {
    $.ajax({
    url: "http://124.222.105.205:5000/api/statistics/reApplyProfessionalCertifica",
    data: {
      professionalId: professionalId.value,
      link: link,
      certificaId: id
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        ElMessage({
          type: "success",
          message: resp.msg
        });
        getCourse();
      } else {
        ElMessage({
          type: "error",
          message: resp.msg
        });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "服务端异常!请稍后再试!"
      });
    },
  });
})
.catch(() => {
  ElMessage({
    type: "info",
    message: "取消",
  });
});
};


</script>

<style scoped>
  .courseImg {
    width:200px;
  }

  .certifica {
    width: 400px;
}

.cBtn {
    float: right;
    margin-top: 80px;
}
</style>